/**
 * Store pour l'overlay d'erreur (gravité unique : rouge / grave)
 * @category ErrorOverlay
 */
let currentNotification = null;
let listeners = [];

/**
 * @param {string} message
 * @param {string|null} [title=null]
 */
export function setError(message, title = null) {
  currentNotification = { message, title };
  listeners.forEach((cb) => cb(currentNotification));
}

export function clearError() {
  currentNotification = null;
  listeners.forEach((cb) => cb(null));
}

export function subscribe(callback) {
  listeners.push(callback);
  return () => {
    listeners = listeners.filter((c) => c !== callback);
  };
}

export function getError() {
  return currentNotification;
}
